@if (!shouldHideGtgtChip()) {
<div class="hmf-position-relative">
	<span
		#anchorChip
		class="hmf-display-inline-block hmf-position-relative"
		tabindex="-1"
		(keydown.tab)="handleDesktopPopoverTab($event)"
		(keydown.shift.tab)="handleDesktopPopoverShiftTab()">
		<hmf-global-chips
			[id]="filter()?.attrIdentifier | filterId:'chip'"
			[label]="chipLabel()"
			type="neutral"
			[disabled]="showSkeletonLoader()"
			[variant]="selectedOptions().length > 0 ? 'prominent' : 'subtle'"
			[size]="isMobile() ? 'small' : 'medium'"
			[showDownButton]="true"
			[isOpen]="isOpen()"
			(handleChipClick)="exposedFilterAction()"
			(handleDown)="exposedFilterAction()">
		</hmf-global-chips>
	</span>
</div>
}
